import Head from 'next/head';
import { Global, css } from '@emotion/react';
import PaperlogyFontFace from '@/features/main/v5/components/PaperlogyFontFace/PaperlogyFontFace';
import { fontAsset } from '@/features/common/fontAssets';

// 특장점과 과목 페이지가 같은 Paperlogy 1.000 Black 파일과 OFL.txt를 공유한다.
const blackFont = fontAsset('paperlogy', 'paperlogy-900.woff2');

export default function PagePaperlogyFontFace() {
    return (
        <>
            <PaperlogyFontFace />
            <Head>
                <link rel="preload" as="font" type="font/woff2" href={blackFont} crossOrigin="anonymous" />
            </Head>
            <Global
                styles={css`
                    @font-face {
                        font-family: 'Paperlogy';
                        font-style: normal;
                        font-weight: 900;
                        font-display: swap;
                        src: url('${blackFont}') format('woff2');
                    }
                `}
            />
        </>
    );
}
